module.exports = __webpack_public_path__ + "img/3.041d52ed.png";